import { useContext } from 'react';
import { createContext } from 'react';

import { ProductHighlightsProps } from '../@types/ProductHighlightsProps';

export const ProductHighlightsContext = createContext<ProductHighlightsProps>({} as ProductHighlightsProps);

ProductHighlightsContext.displayName = 'ProductHighlights';

const ProductHighlightsProvider = (props: ProductHighlightsProps) => (
	<ProductHighlightsContext.Provider value={props}>{props.children}</ProductHighlightsContext.Provider>
);

export const useProductHighlights = () => {
	const context = useContext(ProductHighlightsContext);

	return context;
};

export default ProductHighlightsProvider;
